import React from "react";
import SRPreviewComponent from "./sr-preview.component";

interface Props {
  onSuccess?: (val: boolean) => void;
}

const SRPreviewContainer = ({ onSuccess }: Props) => {
  return <SRPreviewComponent onSuccess={onSuccess} />;
};

export default SRPreviewContainer;
